import { Button, buttonVariants } from '@/components/Button';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';

export const teamInviteListConfig = (openModal) => {
  return [
    {
      id: 'id',
      name: 'ID',
      sortable: false,
      cellRenderer: (row, rowIndex) => {
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
          >
            {rowIndex + 1}
          </Text>
        );
      },
    },
    {
      id: 'role',
      name: 'Role',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
          >
            {row?.role}
          </Text>
        );
      },
    },
    {
      id: 'invitedBy',
      name: 'InvitedBy',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
          >
            {row?.invitedBy}
          </Text>
        );
      },
    },
    {
      id: 'company',
      name: 'Company',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
          >
            {row?.company}
          </Text>
        );
      },
    },
    {
      id: 'team',
      name: 'Department',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
          >
            {row?.team}
          </Text>
        );
      },
    },
    {
      id: 'action',
      name: 'Action',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Button
              onClick={() => openModal(row?.docId)}
              variant={buttonVariants.primary_rounded}
              text={'Proceed'}
            />
          </div>
        );
      },
    },
  ];
};

export const projectInviteListConfig = (openModal) => {
  return [
    {
      id: 'id',
      name: 'ID',
      sortable: false,
      cellRenderer: (row, rowIndex) => {
        return <div>{rowIndex + 1}</div>;
      },
    },
    {
      id: 'role',
      name: 'Role',
      sortable: false,
      cellRenderer: (row) => {
        return <div>{row?.role}</div>;
      },
    },
    {
      id: 'invitedBy',
      name: 'InvitedBy',
      sortable: false,
      cellRenderer: (row) => {
        return <div>{row?.invitedBy}</div>;
      },
    },
    {
      id: 'company',
      name: 'Company',
      sortable: false,
      cellRenderer: (row) => {
        return <div>{row?.company}</div>;
      },
    },
    {
      id: 'project',
      name: 'Project',
      sortable: false,
      cellRenderer: (row) => {
        return <div>{row?.project}</div>;
      },
    },
    {
      id: 'action',
      name: 'Action',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Button
              onClick={() => openModal(row?.docId)}
              variant={buttonVariants.rounded}
              text={'Proceed'}
            />
          </div>
        );
      },
    },
  ];
};
